import React from 'react';
import {AsyncComponent} from "../../../core/components/router/async-component";
import {EntityScoresWidgetPlaceholder} from "./placeholders/entity-scores-widget.placeholder";

const EntityScoresWidgetAsyncComponent = AsyncComponent(async () => import('./entity-scores-widget' /* webpackChunkName: "entity-scores-widget" */ ));

export const EntityScoresWidgetAsync = (props) => {
  return <React.Suspense fallback={ <EntityScoresWidgetPlaceholder {...props} count={6} gamesCount={4}/>}>
    <EntityScoresWidgetAsyncComponent {...props}/>
  </React.Suspense>
}
